// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"21274830","703":"95bc1d85","787":"78316681"}[chunkId] + ".chunk.js";
};